import {AccountsError, TranslationKey} from "../components/login/useLoginWithEmail";
import {AuthError} from "@firebase/auth";

const invalidEmailPasswordMessage = {key: "account:validation.invalidUsernameOrPassword"};
const emailInUseMessage = {key: "account:validation.emailInUse"};
const weakPasswordMessage = {key: "account:validation.password"};
const wrongPasswordMessage = {key: "account:validation.wrongPassword"};
const invalidLinkOrCodeMessage = {key: "account:validation.invalidLinkOrCode"};
const tooManyRequestsMessage = {key: "account:validation.tooManyAttempts"};
const userDisabledMessage = {key: "account:validation.userDisabled"};
const userNotFoundMessage = {key: "account:validation.userNotFound"};

const firebaseErrors: { [key: string]: TranslationKey } = {
  // https://firebase.google.com/docs/reference/js/auth#autherrorcodes
  "auth/user-not-found": userNotFoundMessage,
  "auth/wrong-password": wrongPasswordMessage,
  "auth/missing-email": invalidEmailPasswordMessage,
  "auth/invalid-email": invalidEmailPasswordMessage,
  "auth/email-already-in-use": emailInUseMessage,
  "auth/weak-password": weakPasswordMessage,
  "auth/invalid-verification-code": invalidLinkOrCodeMessage,
  "auth/invalid-action-code": invalidLinkOrCodeMessage,
  "auth/expired-action-code": invalidLinkOrCodeMessage,
  "auth/code-expired": invalidLinkOrCodeMessage,
  "auth/too-many-requests": tooManyRequestsMessage,
  "auth/user-disabled": userDisabledMessage,
}


export const toAccountsError = (firebaseErr: AuthError, defaultKey: string): AccountsError => {
  const code = firebaseErr.code;
  const i18nKey = firebaseErrors[code] || {key: "account:validation." + defaultKey};
  return {
    i18nKey,
    firebaseCode: code,
  }
};
